import { type IconName } from "components/Icon";
import { Toggle } from "components/Toggle";
import { useTranslation } from "react-i18next";

import type { CrremSettings, CrremTrendMethod, EnergyAnalysisSettingsChange } from "../model/types";

import { EnergyAnalysisSettingsGroup } from "./EnergyAnalysisSettingsGroup";

const TREND_METHODS: { iconName: IconName; key: CrremTrendMethod }[] = [
  { iconName: "TrendUp", key: "regression" },
  { iconName: "BarChart3", key: "average" },
];

type EnergyAnalysisTrendMethodControlProps = {
  disabled?: boolean;
  onChange: EnergyAnalysisSettingsChange;
  settings: CrremSettings;
};

export const EnergyAnalysisTrendMethodControl = ({
  disabled,
  onChange,
  settings,
}: EnergyAnalysisTrendMethodControlProps) => {
  const { t } = useTranslation();
  return (
    <EnergyAnalysisSettingsGroup iconName="Sorting" label={t("BuildingProfile.energyAnalysis.settings.trendMethod")}>
      <Toggle
        disabled={disabled}
        onChange={(method) => onChange("trendMethod", method)}
        options={TREND_METHODS.map((method) => ({
          iconName: method.iconName,
          label: t(`BuildingProfile.energyAnalysis.settings.${method.key}`),
          value: method.key,
        }))}
        value={settings.trendMethod}
      />
    </EnergyAnalysisSettingsGroup>
  );
};
